import { matchPath } from "react-router-dom"
import { coerce, number, object, string, validate } from "superstruct"

import { CATALOG_PATH } from "./catalogPath"

const pageNumber = coerce(number(), string(), (value) => parseInt(value, 10))
const filterPage = object({
    filter: string(),
})
const anyPage = object({
    page: pageNumber,
})
const wrongPage = object({
    filter: pageNumber,
})
const anyFilterPage = object({
    page: pageNumber,
    filter: string(),
})

export function getSubRoutes(pathname: string) {
    const matchCatalogOnline = matchPath(CATALOG_PATH.online, pathname) ?? undefined
    const matchAnyPageOnline = matchPath(CATALOG_PATH.anyPageOnline, pathname) ?? undefined

    if (matchCatalogOnline || matchAnyPageOnline) {
        const [, params] = validate(matchAnyPageOnline?.params, anyPage, {
            coerce: true,
        })
        return {
            routes: {
                path: CATALOG_PATH.online,
                withPageNumber: CATALOG_PATH.anyPageOnline,
            },
            params,
        }
    }
    const matchAnyPageWithFilter = matchPath(CATALOG_PATH.anyPageFilter, pathname) ?? undefined
    if (matchAnyPageWithFilter) {
        const [, params] = validate(matchAnyPageWithFilter?.params, anyFilterPage, {
            coerce: true,
        })
        return {
            routes: {
                path: CATALOG_PATH.anyFilter,
                withPageNumber: CATALOG_PATH.anyPageFilter,
            },
            params,
        }
    }
    const matchAnyFilter = matchPath(CATALOG_PATH.anyFilter, pathname) ?? undefined
    if (matchAnyFilter) {
        const [, params] = validate(matchAnyFilter?.params, wrongPage, {
            coerce: true,
        })
        if (params) {
            return {
                routes: {
                    path: CATALOG_PATH.root,
                    withPageNumber: CATALOG_PATH.anyPage,
                },
                params: { page: params.filter },
            }
        } else {
            const [, params] = validate(matchAnyFilter?.params, filterPage, { coerce: true })
            return {
                routes: {
                    path: CATALOG_PATH.anyFilter,
                    withPageNumber: CATALOG_PATH.anyPageFilter,
                },
                params,
            }
        }
    }
    const match = matchPath(CATALOG_PATH.root, pathname) ?? undefined
    const [, params] = validate(match?.params, anyPage, { coerce: true })
    return {
        routes: {
            path: CATALOG_PATH.root,
            withPageNumber: CATALOG_PATH.anyPage,
        },
        params,
    }
}
